export default function (Component) {
  const _Component = Component
  _Component.__i18n = _Component.__i18n || []
  _Component.__i18n.push({
    "locale": "",
    "resource": {
      "en": {
        "date": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Scheduled status change date"])},
        "time": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Time"])},
        "schedule": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Schedule status change for a later date?"])}
      },
      "fr": {
        "date": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Date prévue pour le changement de statut"])},
        "time": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Time"])},
        "schedule": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Programmer le changement de statut pour une date ultérieure?"])}
      }
    }
  })
}